<template>
  <div class="page">
    <transition name="fade">
      <div class="m-nav" v-if="active==1">
      <div class="m-title">
        <div><span>1</span></div>
        <span>付款<span style="color: red;font-size: 14px">（付款成功后请勿重复支付！）</span></span>
      </div>
      <div class="m-des" style="font-size: 14px">{{objHtml.payOperatingSteps}}</div>
      <div class="m-code">
        <img v-if="objHtml.payMainPhoto" :src="objHtml.payMainPhoto" alt="" @click="isShow=true">
      </div>
      <p v-if="objHtml.payMainPhoto" class="m-text" @click="isShow=true">点击支持放大下载</p>
      <div class="m-size-more" v-html="objHtml.payMattersAttention"></div>
      <div v-if="paySampleGraph.length" class="m-eye" @click="goPic(0)">
        <van-icon class="m-eye-ice" name="eye-o" />
        <span>查看付款流程示例</span>
      </div>

    </div>
    </transition>
    <div class="m-nav" v-if="active==2">
      <div class="m-title">
        <div><span>2</span></div>
        <span>上传订单截图</span>
      </div>
      <p class="m-des">{{objHtml.shotOperatingSteps}}</p>
      <div class="m-up-box">
        <div v-if="!imgUrl" class="m-upload-box" @click="goLook()">
          <van-icon class="m-plus" name="plus"/>
          <span>点击上传</span>
        </div>
        <div v-if="imgUrl" class="m-pic">
          <img :src="imgUrl" alt="">
          <van-icon class="m-x" name="close" @click="imgUrl=''"/>
        </div>
      </div>
      <div v-if="objHtml.hasOrderPhotoMerchantNum&&objHtml.hasOrderPhotoMerchantNum==1" class="m-nave">
        <van-field :type="objHtml.hasOrderPhotoMerchantNumOnlyNum&&objHtml.hasOrderPhotoMerchantNumOnlyNum==1 ? 'number' : '' " label="商户单号" placeholder="请输入单号" required v-model="merchantNum"/>
      </div>
      <p class="m-tip" v-html="objHtml.shotMattersAttention"></p>
    </div>
   <div class="m-footer-bt">
     <div style="display: flex">
       <van-button v-if="active==2" block class="x-btn-default" style="margin-right: 20px" @click="active=1">上一步</van-button>
       <van-button v-if="active!=1" size="normal" block @click="goTo()" class="x-btn-log m-width">提 交</van-button>
     </div>
     <van-button v-if="active==1&&register.hasOrderPhoto!=1" size="normal" block @click="goTo()" class="x-btn-log m-width">提 交</van-button>
     <van-button  v-if="register.hasOrderPhoto==1&&active==1" size="normal" block @click="goNext()" class="x-btn-log m-width">下一步</van-button>
   </div>
    <!--弹出框-->
    <div v-show="isShow" @click="isShow=false" class="m-pop">
      <img class="m-img" :src="objHtml.payMainPhoto" alt="">
      <div class="m-bts" @click.stop><a class="m-down-box" :href="objHtml.payMainPhoto" download="二维码"><van-icon name="back-top" class="m-ice"/>点击下载</a></div>
    </div>
    <!--查看示例-->
     <div v-show="show" @click="show=false" class="m-pop-cover">
       <p>示例图</p>
       <img :src="this.objHtml.shotSampleGraph" alt="">
       <div @click.stop>
         <van-uploader v-show="!imgUrl" ref="uploader" :multiple="true" :max-count="1" class="m-upload" :after-read="afterRead" :before-read="beforeRead" accept="image/*">
           <div class="m-pic-down"><van-icon class="m-up-ico" name="plus" /><span>上传截图</span></div>
         </van-uploader>
       </div>
     </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { mapGetters } from 'vuex'
  import { ImagePreview } from 'vant'
  export default {
    components: {},
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem'
      }),
    },
    data () {
      return {
        isShow: false,
        show:false,
        imgUrl: '',
        fileList:[],
        objHtml:{},
        active:1,
        register:{},
        paySampleGraph:[],
        merchantNum:'',
      }
    },
    created () {

    },
    methods: {
      afterRead (e) {
        this.show = false
        let msg = new FormData()
        msg.append('file', e.file)
        this.http.postRequest({
          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/common/upload',
          msg: msg,
          special: true
        }, true).then((res) => {
          if (res.code == 200) {
            this.imgUrl = res.url
          } else {
            this.utils.toastNone(res.msg || res.code)
          }
        }, true)
      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>20971520){ 
          this.utils.toastError('文件大小不能超过20MB！')
          return false
        }
        return true
      },
      //提交
      goTo(){
        if((!this.imgUrl)&&(this.register.hasOrderPhoto==1)){
          this.utils.toastNone('请上传订单详情截图！')
          return
        }
        if(!this.CONFIG_ITEM.id){
          this.utils.toastNone('缺少id！')
          return
        }
        if(this.objHtml.hasOrderPhotoMerchantNum&&this.objHtml.hasOrderPhotoMerchantNum==1){
          if(!this.merchantNum){
            this.utils.toastNone('请填写商户单号！')
            return
          }
          if(this.objHtml.hasOrderPhotoMerchantNumLimitNum&&this.objHtml.hasOrderPhotoMerchantNumLimitNum>0){
            if((this.merchantNum+'').length!=this.objHtml.hasOrderPhotoMerchantNumLimitNum){
              this.utils.toastNone('单号输入不符合要求！')
              return
            }
          }
//          if(this.objHtml.hasOrderPhotoMerchantNumOnlyNum&&this.objHtml.hasOrderPhotoMerchantNumOnlyNum==1){
//            if(){
//              return
//            }
//          }
        }
        let params = JSON.parse(this.$route.params.msg)
        let msg = {
          ...params,
          paymentPhoto:this.imgUrl,
        }
        if(this.objHtml.hasOrderPhotoMerchantNum&&this.objHtml.hasOrderPhotoMerchantNum==1){
          msg.merchantNum = this.merchantNum
        }
        this.http.postRequest({
          url:'app/exam/submitUserExamInfo',
          msg:msg,
          success:(res)=>{
            this.$router.push({
              path:'/enrollSuccess',
              query:{
                isCodePay:true
              }
            })
          }
        },true)
//        this.http.postRequest({
//          url:`app/exam/submitPaymentPhoto/${this.CONFIG_ITEM.id}`,
//          msg:this.imgUrl,
//          success:(res)=>{
//            this.$router.push({
//              path:'/enrollSuccess',
//              query:{
//                isCodePay:true
//              }
//            })
//          }
//        })
      },
      goLook () {
        if(this.objHtml.shotSampleGraph){
          this.show = true
        }else {
          this.$refs.uploader.chooseFile()
        }
      },
      isOk(){

      },
      getSetCofig(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            this.register = res.data&&res.data.register ? res.data&&res.data.register : {}
          }
        })
        this.http.getRequest({
          url:`app/exam/queryOffPayInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            this.objHtml = res.data
            if(this.objHtml.paySampleGraph){
              this.paySampleGraph = this.objHtml.paySampleGraph.split(',')
            }
          }
        })
      },
      goPic (i) {
        ImagePreview({
          images: this.paySampleGraph,
          startPosition: i,
        })
      },
      goNext(){
        this.active = 2
      }
    },
    mounted () {
      if(!this.CONFIG_ITEM.id){
        this.$router.replace('/mySelf')
      }
      if(!(this.$route.params&&this.$route.params.msg)){
        this.$router.go(-1)
      }
      this.getSetCofig()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
   
  @import "~@/assets/css/variable.less";
  .page {
    background: #F4F6F9;
    padding: 0 12px 80px 12px;
    overflow-x: hidden;
    .fade-enter-active,
    .fade-leave-active {
      transition: transform .9s , opacity .4s , cubic-bezier(.49,.66,1,.41);
    }
    .fade-enter{
      position: absolute;
      opacity: 1;
      transform: translateX(100%);
    }
    .fade-leave-to{
      position: absolute;
      opacity: 1;
      transform: translateX(100%);
    }
    .m-nav{
      margin-top: 15px;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-title{
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        >div{
          width: 18px;
          height: 18px;
          font-size: 14px;
          background: #457DF9;
          border-radius: 50%;
          color: #ffffff;
          text-align: center;
          line-height: 18px;
        }
        >span{
          font-size: 15px;
          color: #457DF9;
          font-weight: bold;
          margin-left: 6px;
        }
      }
      .m-des{
        color: #999999;
        font-size: 14px;
        line-height: 18px;
      }
      .m-code{
        width: 160px;
        height: 160px;
        background: #F8F8F8;
        margin: 15px auto 12px auto;
        >img{
          width: 160px;
          height: 160px;
        }
      }
      .m-text{
        text-align: center;
        font-size: 14px;
      }
      .m-size-more{
        margin-top: 20px;
        /*margin-top: 15px;*/
        /*font-size: 14px;*/
        /*color: #999999;*/
        /*>p{*/
          /*line-height: 18px;*/
          /*>span{*/
            /*color: red;*/
          /*}*/
        /*}*/
      }
      .m-eye{
        display: flex;
        align-items: center;
        justify-content: center;
        color: #457DF9;
        font-size: 15px;
        margin-top: 40px;
        margin-bottom: 15px;
        .m-eye-ice{
          font-weight: bold;
          margin-right: 8px;
        }
      }
      .m-up-box {
        display: flex;
        justify-content: center;
        margin-top: 15px;
        .m-upload-box {
          width: 160px;
          height: 160px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #FAFAFA;
          .m-plus {
            font-size: 40px;
            color: #B7B7B7;
          }
          > span {
            margin-top: 8px;
            font-size: 16px;
            color: #B7B7B7;
          }
        }
        .m-pic{
          width: 160px;
          height: 160px;
          position: relative;
          >img{
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .m-x{
            position: absolute;
            right: -5px;
            top: -5px;
            z-index: 100;
            font-size: 23px;
            color: #7e8c8d;
          }
        }
      }
      .m-nave{
        margin-top: 5px;
      }
      .m-tip{
        margin: 40px 0 20px 0;
      }
    }
    .m-width{
      width: 320px!important;
      margin: 0 auto;
    }
    .m-pop{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background:rgba(0,0,0,0.7);
      z-index: 1000;
      text-align: center;
      .m-img{
        width: 270px;
        height: 270px;
        margin: 183px 0 20px 0;
      }
      .m-bts{
        margin: 0 auto;
        width: 120px;
        height: 36px;
        background: rgba(255,255,255,0.4);
        border-radius: 2px;
        border: 2px solid #FFFFFF;
        .m-down-box{
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 15px;
          .m-ice{
            transform: rotate(180deg);
            margin-right: 4px;
            font-size: 16px;
            font-weight: bold;
            position: relative;
            top:-2px;
          }
        }
      }
    }
    .m-pop-cover{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background:rgba(0,0,0,0.7);
      z-index: 1000;
      text-align: center;
      >p{
        color: white;
        margin-top: 50px;
      }
      >img{
        width: 240px;
        margin:  20px 0 30px 0;
      }
      .m-pic-down{
        width: 120px;
        height: 35px;
        background: rgba(255,255,255,0.4);
        border-radius: 4px 4px 4px 4px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        .m-up-ico{
          margin-right: 4px;
          font-weight: bold;
          font-size: 14px;
        }
      }
    }
    .m-footer-bt{
      position: fixed;
      left: 15px;
      right: 15px;
      bottom: 30px;
    }
  }
</style>

